module.exports = __webpack_public_path__ + "static/media/melbourne.0aeb5c99.svg";